import { Box, Grid, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import ControlPanel from '../../ControlPanel';
import CombinedBarChartRecharts from '../../CombinedBarChartRecharts';
import PatientDrilldownModal from '../../PatientDrilldownModal';
import ErrorState from './ErrorState';

const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    paddingTop: theme.spacing(2),
    height: '100%',
    minHeight: '600px',
  },
  gridContainer: {
    height: '100%',
    margin: 0,
    width: '100%',
    flexDirection: 'column',
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.up('lg')]: {
      flexWrap: 'wrap',
      flexDirection: 'row',
    },
  },
  leftPanel: {
    height: '100%',
    width: '100%',
    paddingRight: theme.spacing(1.5),
    flexDirection: 'row',
    display: 'flex',

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'column',
      flex: '0 0 330px',
      maxWidth: '330px',
    },
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
      paddingBottom: theme.spacing(2),
      height: 'min-content',
    },
  },
  rightPanel: {
    height: '100%',
    width: '100%',
    paddingLeft: theme.spacing(1.5),
    [theme.breakpoints.up('lg')]: {
      flex: '1 1 auto',
      maxWidth: 'calc(100% - 330px)',
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingTop: theme.spacing(1),
    },
  },
}));

const DashboardLayout = ({
                           // Control panel props
                           onExport,
                           onExportChart,
                           // Loading states
                           isPngExporting,
                           isPdfExporting,
                           isDataExporting,
                           // Chart props
                           metrics,
                           onMetricClick,
                           chartRef,
                           // Modal props
                           selectedMetric,
                           isModalOpen,
                           onModalClose,
                           hasError,
                           error,
                         }) => {
  const classes = useStyles();
  const { isComparisonMode, totalPatients } = useSelector((state) => state.populationHealth);

  return (
    <Box className={classes.dashboardContainer}>
      <Grid container className={classes.gridContainer}>
        {/* Left Panel - Controls */}
        <Grid item xs={12} className={classes.leftPanel}>
          <ControlPanel
            onExport={onExport}
            onExportChart={onExportChart}
            isPngExporting={isPngExporting}
            isPdfExporting={isPdfExporting}
            isDataExporting={isDataExporting}
          />
        </Grid>


        {
          hasError
            ? <ErrorState />
            : <Grid item xs={12} className={classes.rightPanel}>
              <div
                ref={chartRef}
                style={{
                  height: '100%',
                  paddingBottom: '20px', // Extra space for X-axis labels
                  overflow: 'visible',     // Ensure labels are not clipped
                  outline: 'transparent !important',
                }}
              >
                <CombinedBarChartRecharts
                  metrics={metrics}
                  onMetricClick={onMetricClick}
                  isComparisonMode={isComparisonMode}
                />
              </div>
            </Grid>
        }
      </Grid>

      {/* Patient Drilldown Modal */}
      <PatientDrilldownModal
        open={isModalOpen}
        onClose={onModalClose}
        metric={selectedMetric}
        isComparisonMode={isComparisonMode}
        totalPatients={totalPatients}
      />
    </Box>
  );
};

export default DashboardLayout;
